export const ON_CHANGE = 'visuals-view-changed';
